import { Avatar, Divider, Drawer } from "@material-ui/core";
import { VerifiedUserOutlined } from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Profile, SidebarNav } from "./components";
const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up("lg")]: {
      marginTop: 64,
      height: "calc(100% - 64px)",
    },
  },
  root: {
    backgroundColor: theme.palette.white,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(2),
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  smallAvatar: {
    width: 20,
    borderRadius: 0,
    height: 20,
  },
  nav: {
    marginBottom: theme.spacing(2),
  },
}));

const Sidebar = (props) => {
  const { open, variant, onClose, className, ...rest } = props;
  const current_role = useSelector((state) => state.role);
  // const current_user = useSelector((state) => state.userCurrent);
  let Permission = useSelector((state) => state.permission);

  const classes = useStyles();
  const [ALLpages, setALLPages] = useState([
    {
      title: "ثبت بار جدید",
      href: "/add-shipment",
      // icon:   <Avatar className={classes.smallAvatar} src="/images/logos/contract.svg" />
      icon: (
        <Avatar
          alt="dashboard"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/cargo_menu.svg"
        />
      ),
    },
    {
      title: "لیست اعلام بارها",
      href: "/list-shipment",
      icon: (
        <Avatar
          alt="list contract"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/list_contract.svg"
        />
      ),
    },
    {
      title: "لیست پرداختی ها ",
      href: "/list-payment",
      icon: (
        <Avatar
          alt="list payment"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/payment.svg"
        />
      ),
    },
    {
      title: "لیست درخواست ها",
      href: "/list-request",
      icon: (
        <Avatar
          alt="list contract"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/hello.svg"
        />
      ),
    },
    {
      title: "داشبورد",
      href: "/dashboard",
      icon: (
        <Avatar
          alt="dashboard"
          style={{ width: 28, height: 28, borderRadius: 0 }}
          src="/images/dashboard.svg"
        />
      ),
    },
    {
      title: "درخواست های احراز هویت",
      href: "/auth-requests",
      icon: (
        <VerifiedUserOutlined
          style={{
            color: "rgba(0, 0, 0, 0.33)",

            fontSize: 30,
          }}
        />
      ),
    },
    {
      title: "لیست کارمندان",
      href: "/users",
      icon: (
        <Avatar
          alt="users"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/group.svg"
        />
      ),
    },

    {
      title: "مدیریت مشاغل",
      href: "/company",
      icon: (
        <Avatar
          alt="company"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/company.svg"
        />
      ),
    },
    {
      title: "مدیریت رانندگان ",
      href: "/manage-drivers",
      icon: (
        <Avatar
          alt="manage-drivers"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/driverIcon.svg"
        />
      ),
    },
    {
      title: "مدیریت شهرها ",
      href: "/manage-city",
      icon: (
        <Avatar
          alt="manage-city"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/citySvg.svg"
        />
      ),
    },
    {
      title: "ارسال نوتیفیکیشن",
      href: "/send-notification",
      icon: (
        <Avatar
          alt="send-notification"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/notif.svg"
        />
      ),
    },
  ]);
  const [pages, setPages] = useState([
    {
      title: "ثبت بار جدید",
      href: "/add-shipment",
      // icon:   <Avatar className={classes.smallAvatar} src="/images/logos/contract.svg" />
      icon: (
        <Avatar
          alt="dashboard"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/cargo_menu.svg"
        />
      ),
    },
    {
      title: "لیست اعلام بارها",
      href: "/list-shipment",
      icon: (
        <Avatar
          alt="list contract"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/list_contract.svg"
        />
      ),
    },
    {
      title: "لیست پرداختی ها ",
      href: "/list-payment",
      icon: (
        <Avatar
          alt="list payment"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/payment.svg"
        />
      ),
    },

    {
      title: "لیست درخواست ها",
      href: "/list-request",
      icon: (
        <Avatar
          alt="list contract"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/hello.svg"
        />
      ),
    },
    {
      title: "داشبورد",
      href: "/dashboard",
      icon: (
        <Avatar
          alt="dashboard"
          style={{ width: 28, height: 28, borderRadius: 0 }}
          src="/images/dashboard.svg"
        />
      ),
    },
    {
      title: "درخواست های احراز هویت",
      href: "/auth-requests",
      icon: (
        <VerifiedUserOutlined
          style={{
            color: "rgba(0, 0, 0, 0.33)",

            fontSize: 20,
          }}
        />
      ),
    },

    {
      title: "لیست کارمندان",
      href: "/users",
      icon: (
        <Avatar
          alt="users"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/group.svg"
        />
      ),
    },

    {
      title: "مدیریت مشاغل",
      href: "/company",
      icon: (
        <Avatar
          alt="company"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/company.svg"
        />
      ),
    },
    {
      title: "مدیریت رانندگان ",
      href: "/manage-drivers",
      icon: (
        <Avatar
          alt="manage-drivers"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/driverIcon.svg"
        />
      ),
    },
    {
      title: "مدیریت شهرها ",
      href: "/manage-city",
      icon: (
        <Avatar
          alt="manage-city"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/citySvg.svg"
        />
      ),
    },
    {
      title: "ارسال نوتیفیکیشن",
      href: "/send-notification",
      icon: (
        <Avatar
          alt="send-notification"
          style={{ width: 30, height: 30, borderRadius: 0 }}
          src="/images/notif.svg"
        />
      ),
    },
  ]);

  // const getUser

  // if (current_role != "Super-Admin") {
  //   pages = pages.filter((e) => e.href !== "/company");
  //   pages = pages.filter((e) => e.href !== "/manage-drivers");
  //   pages = pages.filter((e) => e.href !== "/send-notification");

  //   pages = pages.filter((e) => e.href !== "/users");
  // }

  function UpdateMenu2() {
    if (Permission != null) {
      let Pr_inventory = [...Permission];
      let pg = [];
      pg = pages;

      // pg = pg.filter((e) => e.href != '/add-kala');
      // pg = [...pg, ALLpages.filter((e) => e.href == '/add-kala')['0']];

      // permission add shipment
      if (Pr_inventory.indexOf("shipment.add") == -1) {
        if (pg.some((pg_item) => pg_item.href == "/add-shipment")) {
          pg = pg.filter((e) => e.href != "/add-shipment");
        }
      } else if (Pr_inventory.indexOf("shipment") != -1) {
        if (!pg.some((pg_item) => pg_item.href == "/add-shipment")) {
          pg = [...pg, ALLpages.filter((e) => e.href == "/add-shipment")["0"]];
        }
      }
      // end permission add shipment

      // permission manage city
      if (
        Pr_inventory.indexOf("manage-cities.create") == -1 &&
        Pr_inventory.indexOf("manage-cities.edit") == -1
      ) {
        if (pg.some((pg_item) => pg_item.href == "/manage-city")) {
          pg = pg.filter((e) => e.href != "/manage-city");
        }
      } else if (
        Pr_inventory.indexOf("manage-cities.create") != -1 ||
        Pr_inventory.indexOf("manage-cities.edit") != -1
      ) {
        if (!pg.some((pg_item) => pg_item.href == "/manage-city")) {
          pg = [...pg, ALLpages.filter((e) => e.href == "/manage-city")["0"]];
        }
      }
      // end permission manage city

      // permission manage notification
      if (Pr_inventory.indexOf("manage-notifications.send") == -1) {
        if (pg.some((pg_item) => pg_item.href == "/send-notification")) {
          pg = pg.filter((e) => e.href != "/send-notification");
        }
      } else if (Pr_inventory.indexOf("manage-notifications.send") != -1) {
        if (!pg.some((pg_item) => pg_item.href == "/send-notification")) {
          pg = [
            ...pg,
            ALLpages.filter((e) => e.href == "/send-notification")["0"],
          ];
        }
      }
      // end permission manage notification

      // permission manage dashbord
      if (Pr_inventory.indexOf("dashboard.viewAny") == -1) {
        if (pg.some((pg_item) => pg_item.href == "/dashboard")) {
          pg = pg.filter((e) => e.href != "/dashboard");
        }
      } else if (Pr_inventory.indexOf("dashboard.viewAny") != -1) {
        if (!pg.some((pg_item) => pg_item.href == "/dashboard")) {
          pg = [...pg, ALLpages.filter((e) => e.href == "/dashboard")["0"]];
        }
      }
      // end permission manage dashbord

      // permission manage request
      if (Pr_inventory.indexOf("shipmentRequest.view") == -1) {
        if (pg.some((pg_item) => pg_item.href == "/list-request")) {
          pg = pg.filter((e) => e.href != "/list-request");
        }
      } else if (Pr_inventory.indexOf("shipmentRequest.view") != -1) {
        if (!pg.some((pg_item) => pg_item.href == "/list-request")) {
          pg = [...pg, ALLpages.filter((e) => e.href == "/list-request")["0"]];
        }
      }
      // end permission manage request

      // permission list shipment
      if (Pr_inventory.indexOf("shipment.view") == -1) {
        if (pg.some((pg_item) => pg_item.href == "/list-shipment")) {
          pg = pg.filter((e) => e.href != "/list-shipment");
        }
      } else if (Pr_inventory.indexOf("shipment.view") != -1) {
        if (!pg.some((pg_item) => pg_item.href == "/list-shipment")) {
          pg = [...pg, ALLpages.filter((e) => e.href == "/list-shipment")["0"]];
        }
      }
      // end permission list shipment

      // permission list payment
      if (Pr_inventory.indexOf("transaction.see-report") == -1) {
        if (pg.some((pg_item) => pg_item.href == "/list-payment")) {
          pg = pg.filter((e) => e.href != "/list-payment");
        }
      } else if (Pr_inventory.indexOf("transaction.see-report") != -1) {
        if (!pg.some((pg_item) => pg_item.href == "/list-payment")) {
          pg = [...pg, ALLpages.filter((e) => e.href == "/list-payment")["0"]];
        }
      }
      // end permission list payment

      // permission add shipment
      if (Pr_inventory.indexOf("shipment.add") == -1) {
        if (pg.some((pg_item) => pg_item.href == "/add-shipment")) {
          pg = pg.filter((e) => e.href != "/add-shipment");
        }
      } else if (Pr_inventory.indexOf("shipment.add") != -1) {
        if (!pg.some((pg_item) => pg_item.href == "/add-shipment")) {
          pg = [...pg, ALLpages.filter((e) => e.href == "/add-shipment")["0"]];
        }
      }
      // end permission add shipment

      // permission manage drivers
      if (
        Pr_inventory.indexOf("manage-drivers.create") == -1 &&
        Pr_inventory.indexOf("manage-drivers.view") == -1
      ) {
        if (pg.some((pg_item) => pg_item.href == "/manage-drivers")) {
          pg = pg.filter((e) => e.href != "/manage-drivers");
        }
      } else if (
        Pr_inventory.indexOf("manage-drivers.create") != -1 ||
        Pr_inventory.indexOf("manage-drivers.view") != -1
      ) {
        if (!pg.some((pg_item) => pg_item.href == "/manage-drivers")) {
          pg = [
            ...pg,
            ALLpages.filter((e) => e.href == "/manage-drivers")["0"],
          ];
        }
      }
      // end permission manage drivers

      // permission manage company
      if (
        Pr_inventory.indexOf("company.add") == -1 &&
        Pr_inventory.indexOf("company.view") == -1 &&
        Pr_inventory.indexOf("company.viewAny") == -1
      ) {
        if (pg.some((pg_item) => pg_item.href == "/company")) {
          pg = pg.filter((e) => e.href != "/company");
        }
      } else if (
        Pr_inventory.indexOf("company.add") != -1 ||
        Pr_inventory.indexOf("company.viewAny") != -1 ||
        Pr_inventory.indexOf("company.view") != -1
      ) {
        if (!pg.some((pg_item) => pg_item.href == "/company")) {
          pg = [...pg, ALLpages.filter((e) => e.href == "/company")["0"]];
        }
      }
      // end permission manage company

      // permission manage Staff
      if (
        Pr_inventory.indexOf("staff.add") == -1 &&
        Pr_inventory.indexOf("staff.view") == -1 &&
        Pr_inventory.indexOf("staff.viewAny") == -1
      ) {
        if (pg.some((pg_item) => pg_item.href == "/users")) {
          pg = pg.filter((e) => e.href != "/users");
        }
      } else if (
        Pr_inventory.indexOf("staff.add") != -1 ||
        Pr_inventory.indexOf("staff.viewAny") != -1 ||
        Pr_inventory.indexOf("staff.view") != -1
      ) {
        if (!pg.some((pg_item) => pg_item.href == "/users")) {
          pg = [...pg, ALLpages.filter((e) => e.href == "/users")["0"]];
        }
      }
      // end permission manage Staff
      setPages(pg);

      if (current_role == "Super-Admin") {
        setPages(ALLpages);
      }
    }
  }

  useEffect(() => {
    UpdateMenu2();
  }, [Permission]);

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div {...rest} className={clsx(classes.root, className)}>
        <Profile />
        {current_role !== "Super-Admin" && (
          <SidebarNav
            onClose={onClose}
            // className={classes.nav}
            pages={[
              {
                title: "درخواست احراز هویت",
                href: "/auth",
                // icon:   <Avatar className={classes.smallAvatar} src="/images/logos/contract.svg" />
                icon: (
                  <VerifiedUserOutlined
                    style={{
                      color: "rgba(0, 0, 0, 0.33)",

                      fontSize: 30,
                    }}
                  />
                ),
              },
            ]}
          />
        )}

        <Divider className={classes.divider} />
        <SidebarNav onClose={onClose} className={classes.nav} pages={pages} />
        {/* <UpgradePlan /> */}
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
};

export default Sidebar;
